{
    "name": "hub4b-frontoffice",
    "version": "1.4.2",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint"
    },
    "private": true,
    "dependencies": {
        "@angular-eslint/schematics": "^19.2.1",
        "@angular/animations": "^19.2.3",
        "@angular/cdk": "^19.2.4",
        "@angular/common": "^19.2.3",
        "@angular/compiler": "^19.2.3",
        "@angular/core": "^19.2.3",
        "@angular/forms": "^19.2.3",
        "@angular/localize": "^19.2.3",
        "@angular/material": "^19.2.4",
        "@angular/material-moment-adapter": "^19.2.4",
        "@angular/platform-browser": "^19.2.3",
        "@angular/platform-browser-dynamic": "^19.2.3",
        "@angular/router": "^19.2.3",
        "@fortawesome/angular-fontawesome": "^1.0.0",
        "@fortawesome/fontawesome-svg-core": "^6.7.2",
        "@fortawesome/free-regular-svg-icons": "^6.7.2",
        "@fortawesome/free-solid-svg-icons": "^6.7.2",
        "@kolkov/angular-editor": "^2.1.0",
        "@ngxmc/datetime-picker": "^19.1.0",
        "angular-split": "^19.0.0",
        "apexcharts": "^4.3.0",
        "dompurify": "^3.2.4",
        "js-base64": "^3.7.7",
        "jsonpath-plus": "^10.2.0",
        "memoizee": "^0.4.17",
        "moment": "^2.30.1",
        "ng-apexcharts": "^1.15.0",
        "ng-mat-select-infinite-scroll": "^4.0.0",
        "ng2-file-upload": "^8.0.0",
        "ngx-cookie-service": "^19.1.2",
        "ngx-infinite-scroll": "^19.0.0",
        "ngx-quill": "^27.0.1",
        "ngx-spinner": "^19.0.0",
        "ngx-toastr": "^19.0.0",
        "panzoom": "^9.4.3",
        "quill": "^2.0.3",
        "rxjs": "~7.8.2",
        "uuid": "^11.0.3",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.2.3",
        "@angular-eslint/builder": "19.2.1",
        "@angular-eslint/eslint-plugin": "19.2.1",
        "@angular-eslint/eslint-plugin-template": "19.2.1",
        "@angular-eslint/template-parser": "19.2.1",
        "@angular/cli": "^19.2.4",
        "@angular/compiler-cli": "^19.2.3",
        "@types/node": "^22.13.10",
        "@typescript-eslint/eslint-plugin": "8.27.0",
        "@typescript-eslint/parser": "8.27.0",
        "eslint": "^9.22.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.1.0",
        "prettier": "3.5.3",
        "ts-node": "^10.9.2",
        "typescript": "~5.8.2"
    },
    "overrides": {
        "ng2-file-upload": {
            "@angular/common": ">=16.0.0",
            "@angular/core": ">=16.0.0"
        },
        "ng-mat-select-infinite-scroll": {
            "@angular/core": ">=16.0.0",
            "@angular/material": ">=16.0.0",
            "@angular/cdk": ">=16.0.0"
        }
    }
}
